module.exports = __webpack_public_path__ + "static/media/Dropbox.36533124.png";